import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pages from './en-US/pages';
import pwa from './en-US/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',

  'menu.withdrawal': 'Withdrawal',
  'menu.subscription': 'Subscription',
  'menu.refund': 'Refund',

  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,

  'pages.withdrawRecord.updateForm.withdrawal.tgid': 'tgid',
  "pages.withdrawRecord.availableBalance": "available balance",
  "pages.withdrawRecord.beforeBalance": "before balance",
  "pages.withdrawRecord.create_time": "apply time",
  "pages.withdrawRecord.confirm_time": "confirm time",
  "pages.withdrawRecord.draw_num": "draw money",
  "pages.withdrawRecord.draw_total": "draw total",
  "pages.withdrawRecord.u_machine_level": "machine level",
  "pages.withdrawRecord.open_num": "open number",
  "pages.withdrawRecord.draw_count": "draw number",
  "pages.withdrawRecord.free": "draw free",
  "pages.withdrawRecord.is_accelerate": "is accelerate",
  "pages.withdrawRecord.status": "status",
  "pages.withdrawRecord.rejected": "rejected",
  "pages.withdrawRecord.confirm": "confirm",
  "pages.withdrawRecord.u_username": "username",
  "pages.withdrawRecord.updateForm.withdrawal.avatar": "avatar",
  "pages.withdrawRecord.destroy_machine": "destroy machine",
};
